<template>
  <asc-notification
    :definition="definition"
    :on-close="onClose"
    :on-toast-action="onToastAction"
    class="asc-confirmation"
  ></asc-notification>
</template>

<script>
import AscNotification from '@/components/molecules/AscNotification'
export default {
  name: 'AscConfirmation',

  components: { AscNotification },

  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    onToastAction: {
      type: Function,
      default: () => {},
    },
    definition: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.asc-notification-wrapper {
  &.asc-confirmation {
    .asc-notification {
      &.notification {
        &--primary {
          .icon-container {
            background-color: $gray-900;
          }
        }
      }

      &.toast {
        bottom: 20px;

        .wrapper {
          background-color: $gray-900;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);

          .icon-container {
            align-items: center;
            display: flex;
            color: $gray-900;
            justify-content: center;
            width: 40px;
            height: 40px;
            padding: 12px 8px 12px 16px;

            .v-icon {
              color: $primary-white;
            }
          }

          .content-wrapper {
            padding: 11px 6px 10px 1px;
            min-height: 40px;
            border: none;
            color: $accent-0;
            font-weight: 300;
          }

          button.toast-action {
            color: $accent-0;
            margin-right: 24px;
            font-weight: 300;
          }

          .v-btn.close .v-icon {
            color: $primary-white;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 600px) {
  .asc-notification-wrapper {
    &.asc-confirmation {
      .asc-notification {
        &.toast {
          .wrapper {
            min-width: 188px;
            max-width: 507px;
          }
        }
      }
    }
  }
}
</style>
